export const SURVEY_APPS = {
  CAMPAIGN_ASSISTANT: 'CAMPAIGN_ASSISTANT',
  BLOG_IDEAS_GENERATOR: 'BLOG_IDEAS_GENERATOR',
  EMAIL_SIGNATURE_GENERATOR: 'EMAIL_SIGNATURE_GENERATOR',
  BRAND_KIT_GENERATOR: 'BRAND_KIT_GENERATOR'
};
export const SURVEY_FORM_MAP = {
  [SURVEY_APPS.CAMPAIGN_ASSISTANT]: {
    QA: 'bcc0d68a-86d8-4846-914b-fa4953107bbc',
    PROD: '8a2bba9b-d950-4c17-a240-7d5e94c81dfe'
  },
  [SURVEY_APPS.BLOG_IDEAS_GENERATOR]: {
    QA: '1be9f356-b2af-4f7f-82dc-54b12d85c4ea',
    PROD: 'c8657b34-1709-40eb-8c8d-6730c2042af1'
  },
  [SURVEY_APPS.EMAIL_SIGNATURE_GENERATOR]: {
    QA: '8df700b7-325b-44d5-b876-ac64361c7a57',
    PROD: '6b256a06-60b3-472a-a7fb-694dd6d66175'
  },
  [SURVEY_APPS.BRAND_KIT_GENERATOR]: {
    QA: 'f9bc01f6-f748-4e66-8bd9-c21f6fc28add',
    PROD: '14e46e97-296c-47eb-b847-d33fb9c3b8e3'
  }
};